/**
 * useHeaderMenu Hook
 * Generates user menu items for Header component
 * Following best practices with useMemo and useCallback
 */

import { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../common/hooks/redux';
import { logOut } from '../../store/slices/authorizationSlice';
import { paths } from '../../routes/paths';
import { UserMenuItem } from '../../components/UserMenu/UserMenu.types';

interface UseHeaderMenuProps {
  userRole: string;
}

export const useHeaderMenu = ({ userRole: _userRole }: UseHeaderMenuProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Handle logout
  const handleLogout = useCallback(() => {
    dispatch(logOut(undefined));
    navigate('/login/sign-in');
  }, [dispatch, navigate]);

  // Generate user menu items
  const userMenuItems = useMemo<UserMenuItem[]>(
    () => [
      // {
      //   id: 'profile',
      //   label: t('common.profile'),
      //   icon: '👤',
      //   path: `/${userRole}${paths.profile || '/profile'}`,
      // },
      {
        id: 'settings',
        label: t('common.settings'),
        icon: '⚙️',
        path: `/owner${paths.settings}`,
      },
      {
        id: 'logout',
        label: t('common.logout'),
        icon: '🚪',
        onClick: handleLogout,
        danger: true,
        dividerBefore: true,
      },
    ],
    [t, handleLogout]
  );

  return {
    userMenuItems,
  };
};
